<template>
  <div class="contanier">
    <div class="htitle">
      <p>Windows版</p>
      <h1>办公电脑使用指南</h1>
    </div>
    <div class="content">
      <div class="title title1">第一步：领取电脑</div>
      <div class="t_box">
        <p class="arrow">
          <img :src="baseUrl + 'arrow.png'" />联系所属小微入职向导进行电脑领取。
        </p>
      </div>
    </div>
    <div class="content">
      <div class="title title2">第二步：检查必装软件</div>
      <div class="t_box t_box2">
        <p class="arrow mbt37">
          <img :src="baseUrl + 'arrow.png'" />1、必装软件包括：
        </p>
        <div class="soft">
          <div><img :src="baseUrl + 'sha.png'" /> ① HUES杀毒软件</div>
          <!-- <div>
            <img :src="baseUrl + 'zhu.png'" />
            ② 联软安全助手
          </div> -->
        </div>
        <p class="arrow mbt37">
          <img
            :src="baseUrl + 'arrow.png'"
          />2、必装软件检查方法：电脑右下角任务栏，打开系统托盘（向上箭头）有无Hues软件的图标。
        </p>
        <img :src="baseUrl + 'phone1.jpg'" class="phone" />
        <p class="arrow mbt46">
          <img
            :src="baseUrl + 'arrow.png'"
          />3、如果没有，请保持电脑可以连接Internet并登录<a
            href="http://vpn.haier.net/"
            target="_blank"
            >vpn.haier.net</a
          >下载安装。
        </p>
        <span>温馨提示：</span>
        <span>这一款软件必须安装，否则可能无法连接网络</span>
      </div>
    </div>
    <div class="content">
      <div class="title title3">第三步：连接网络</div>
      <div class="t_box t_box3">
        <p class="arrow mbt30">
          <img :src="baseUrl + 'arrow.png'" />办公区域内：
        </p>
        <div class="area areaIn">
          <p class="arrow mbt27">1.连接有线网络：</p>
          <p class="description mbt50">直接插入网线即可</p>
          <p class="arrow mbt27">2.连接无线网络：</p>
          <p class="description mbt44">
            操作方法--电脑右下角任务栏，打开系统托盘，点击“地球”图标：<img
              :src="baseUrl + 'map.png'"
              class="map"
            />
          </p>
          <p class="description mbt40 area_text">
            <span>青岛区域：</span
            >选择“Haier-Corp”，点击“连接”，输入员工号及密码即可。显示“无Internet，安全”，即可以认为内网连接正常。
          </p>
          <p class="description mbt37 area_text">
            <span>无Haier-Corp区域：</span>请咨询入职向导或当
            地IT接口人具体连接方式。
          </p>
          <img :src="baseUrl + 'haiercorp.png'" class="haiercorp" />
        </div>

        <p class="arrow mbt30">
          <img :src="baseUrl + 'arrow.png'" />非办公区域内：
        </p>
        <div class="area areaOut">
          <p class="arrow mbt24">
            保持电脑可以连接Internet, 登录
            <a href="http://vpn.haier.net/" target="_blank">vpn.haier.net</a
            >下载、安装集团VPN
          </p>
          <img :src="baseUrl + 'vpn.png'" class="vpn" />
          <p class="arrow mbt30">
            可参照VPN安装使用手册，登录VPN 成功，显示如下图，“您已上线”。
          </p>
          <div class="onLine">
            <img :src="baseUrl + 'vpn2.png'" class="vpn2" />
            <img :src="baseUrl + 'vpn3.png'" class="vpn3" />
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title title4">第四步：加域</div>
      <div class="t_box t_box4">
        <p class="arrow mbt30">
          <img :src="baseUrl + 'arrow.png'" />1、办公电脑必须加域
        </p>
        <span>温馨提示：</span>
        <span>加域要在电脑直接接入内网下进行，VPN接入时无法加域。</span>
        <span>不加域的电脑，可能无法使用内网中的各类系统。</span>
        <p class="arrow mt52 mbt27">
          <img :src="baseUrl + 'arrow.png'" />2、检查方法：
        </p>
        <p class="fs40">
          同时按键盘Ctrl+Alt+Del，点击“切换用户”→“其他用户”若屏幕出现“登录到HAIER”为已加域完成。
        </p>
        <img :src="baseUrl + 'others.png'" class="other" />
        <p class="arrow mbt46">
          <img
            :src="baseUrl + 'arrow.png'"
          />3、如果没有出现“登录到HAIER”，请操作自助加域。
        </p>
        <p class="description">
          操作方法：在完成第三步“连接网络”后，请登录iHaier-工作台-办公云-快捷导航→IT服务→IT支持→电脑自助加域，参照操作指导书完成操作。
        </p>
      </div>
    </div>
    <div class="content prelative">
      <div class="title title5">第五步：常用软件安装</div>
      <div class="t_box t_box5">
        <p class="arrow mbt40">
          <img
            :src="baseUrl + 'arrow.png'"
          />1、常用软件可通过HUES→软件管理，自助下载安装。
        </p>
        <p class="description">
          操作方法：电脑右下角任务栏，打开系统托盘，双击
          HUES图标后，点击软件管理。
        </p>
        <img :src="baseUrl + 'hues.png'" class="hues" />
        <p class="arrow mbt44">
          <img :src="baseUrl + 'arrow.png'" />
          2、Office2021安装配置（适用于非海尔内销电脑）
        </p>
        <p class="description linear">
          ① 请登录HUES→软件管理→办公通用类，下载Office2021安装包；
        </p>
        <p class="arrow mt42 mbt40">
          <img :src="baseUrl + 'arrow.png'" />
          3、Outlook邮箱配置：
        </p>
        <p class="description">
          打开“开始”菜单找到Outlook，右键单击选择“固定到 开始 屏幕”，
          点击“开始”找到Outlook图标，拖到电脑桌面上即可。
        </p>
        <img :src="baseUrl + 'outlook.png'" class="outlook" />
        <p class="arrow mbt30">
          <img :src="baseUrl + 'arrow.png'" />
          4、安装iHaier：
        </p>
        <p class="description linear">方式1： HUES→软件管理 自助下载安装</p>
        <p class="arrow mbt30 mt46">
          <img :src="baseUrl + 'arrow.png'" />
          5、打印机安装配置
        </p>
        <p class="description">
          安装路径：HUES→软件管理→搜索“打印机”或“DYJQD”
          →找到“打印一体机安装DYJQD（不含黄岛园区）” →点击“下载”并完成安装即可。
        </p>
        <p class="arrow mbt30 mt46">
          <img :src="baseUrl + 'arrow.png'" />
          6、安装加密软件（仅适用研发用户）
        </p>
        <p class="description">
          安装路径：HUES→软件管理→“研发专用类”选择部门对应加密安装包下载，安装过程中如有问题，
          请联系加密工程师A0000093。
        </p>
      </div>
      <div class="people">
        <div>
          <p>温馨提示：</p>
          <p>1、海尔品牌的办公电脑硬件故障报修：手机-4006999999</p>
          <p>
            2、海尔员工的办公电脑软件故障报修：网络报修-iHaier搜索“<a
            href="https://nesp.haier.net/index"
            target="_blank"
            >IT 服务台</a
          >”；
          </p>
          <p>手机-4006771000</p>
        </div>
        <img :src="baseUrl + 'bro.png'" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      baseUrl: "//cdn.haier.net/assets/overlay/dts-fe/computer-guide/",
    };
  },
};
</script>
<style lang="less">
.contanier {
  max-width: 1000px;
  width: 1000px;
  height: 100%;
  margin: 0 auto;
  padding: 1560px 32px 620px 32px;
  background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/bg.png")
    no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  position: relative;
  .htitle {
    position: absolute;
    text-align: right;
    top: 139px;
    right: 49px;
    color: #fff;
    p {
      height: 68px;
      font-size: 72px;
      font-family: FZLanTingHeiS-R-GB;
      margin-bottom: 25px;
    }
    h1 {
      height: 105px;
      font-size: 110px;
      font-weight: 600;
    }
  }
  .content {
    width: auto;
    height: auto;
    margin-bottom: 114px;

    .title {
      background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/title1.png")
        no-repeat;
      background-size: 100% 100%;
      height: 170px;
      text-align: center;
      line-height: 170px;
      font-size: 52px;
      font-weight: 600;
      position: relative;
      z-index: 1000;
      color: #ffffff;
    }
    .title1,
    .title2,
    .title3,
    .title5 {
      padding-left: 120px;
    }
    .title2,
    .title4 {
      background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/title2.png")
        no-repeat;
      background-size: 100% 100%;
    }
    .t_box {
      background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/box.png")
        no-repeat;
      background-size: 100% 100%;
      z-index: 999;
      margin-top: -83px;
      position: relative;
      color: #1e2886;
      padding: 120px 64px 60px 64px;
      text-align: left;
      .arrow {
        font-size: 40px;
        word-break: break-all;
        line-height: 50px;
        img {
          width: 48px;
          height: 48px;
          margin-right: 12px;
          vertical-align: sub;
        }
      }
      span {
        display: block;
        font-size: 30px;
        line-height: 48px;
      }
    }
    .t_box2 {
      background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/box2.png")
        no-repeat;
      background-size: 100% 100%;
      .soft {
        display: flex;
        margin-bottom: 37px;
        img {
          width: 183px;
          height: 210px;
          margin-bottom: 37px;
        }
        > div {
          width: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          // &:first-child {
          //   // border-right: 1px solid rgba(43, 64, 158, 0.55);
          // }
        }
      }
      .phone {
        width: 183px;
        height: 250px;
        margin-bottom: 37px;
        margin-left: 110px;
      }
    }
    .t_box3 {
      background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/box3.png")
        no-repeat;
      background-size: 100% 100%;
      padding-bottom: 57px;
      .area {
        padding: 78px 61px 43px 61px;
      }
      .areaIn {
        background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/box3_1.png")
          no-repeat;
        background-size: 100% 100%;
        margin-bottom: 30px;
        .area_text {
          span {
            display: inline-block;
            font-weight: bold;
            font-size: 36px;
          }
        }
        .map {
          width: 100px;
          height: 57px;
          vertical-align: middle;
        }
        .haiercorp {
          width: 428px;
          height: 189px;
        }
      }
      .areaOut {
        background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/box3_2.png")
          no-repeat;
        background-size: 100% 100%;
        .arrow {
          line-height: 55px;
          word-break: break-word;
        }
        .vpn {
          width: 157px;
          height: 178px;
          margin-bottom: 32px;
        }
        .onLine {
          display: flex;
          justify-content: space-between;
          .vpn2 {
            width: 250px;
            height: 209px;
          }
          .vpn3 {
            width: 359px;
            height: 211px;
          }
        }
      }
    }
    .t_box4 {
      background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/box4.png")
        no-repeat;
      background-size: 100% 100%;
      padding-bottom: 85px;
      padding-top: 124px;
      .other {
        width: 733px;
        height: 418px;
        display: inline-block;
        margin: 50px 0 56px 0;
      }
    }
    .t_box5 {
      background: url("//cdn.haier.net/assets/overlay/dts-fe/computer-guide/box5.png")
        no-repeat;
      background-size: 100% 100%;
      padding-top: 105px;
      padding-bottom: 100px;
      .hues {
        width: 610px;
        height: 414px;
        margin-top: 36px;
        margin-bottom: 43px;
      }
      .outlook {
        width: 202px;
        height: 238px;
        margin-top: 29px;
        margin-bottom: 40px;
      }
    }
  }
  .prelative {
    margin-bottom: 0;
    position: relative;
    .people {
      font-size: 36px;
      color: #ddedfa;
      z-index: 1000;
      line-height: 55px;
      display: flex;
      position: absolute;
      bottom: -360px;
      right: -10px;
      left: 25px;
      > div {
        margin-top: 200px;
        max-width: 634px;
      }
      p {
        word-break: break-all;
      }
      img {
        width: 310px;
        min-width: 314px;
        height: 554px;
        position: absolute;
        right: 0;
        top: 180px;
        display: inline-block;
      }
    }
  }

  a {
    color: #1e2886;
  }
  .mbt24 {
    margin-bottom: 24px;
  }
  .mbt27 {
    margin-bottom: 27px;
  }
  .mbt30 {
    margin-bottom: 30px;
  }
  .mbt37 {
    margin-bottom: 37px;
  }
  .mbt40 {
    margin-bottom: 40px;
  }
  .mbt44 {
    margin-bottom: 44px;
  }
  .mbt46 {
    margin-bottom: 46px;
  }
  .mbt50 {
    margin-bottom: 50px;
  }
  .mt42 {
    margin-top: 42px;
  }
  .mt46 {
    margin-top: 46px;
  }
  .mt52 {
    margin-top: 52px;
  }
  .fs40 {
    font-size: 40px;
  }
  .linear {
    padding: 6px 8px;
    margin-bottom: 13px;
    background: linear-gradient(to right, #92d3f5, #bcdaf0);
  }
  .description {
    font-size: 36px;
    line-height: 54px;
    word-break: break-all;
  }
}
</style>
